<template>
  <div>
    <div class="container section">
      <div class="section-title-bar">交易统计</div>
      <div class="section-primary">
        <div class="section-item">
          <div class="section-item-label">累计订单</div>
          <div class="section-item-digit" style="color: #ff4f4f;">
            {{ orderTotal }}
            <span class="unit">单</span>
          </div>
        </div>
        <div class="section-item">
          <div class="section-item-label">累计支付金额</div>
          <div class="section-item-digit" style="color: #ff4f4f;">
            {{ paidTotal / 100 }}
            <span class="unit">元</span>
          </div>
        </div>
        <div class="section-item">
          <div class="section-item-label">累计利润</div>
          <div class="section-item-digit" style="color: #037FFF;">
            {{ profitTotal / 100 }}
            <span class="unit">元</span>
          </div>
        </div>
      </div>

      <div class="section-chart-title">
        交易走势
        <div class="section-chart-op">
          <el-date-picker v-model="dateOrder" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveOrder === 7 }"
            v-on:click="
              () => {
                dateOrder = [yesterday().add(-7, 'days'), yesterday()];
                isActiveOrder = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveOrder === 30 }"
            v-on:click="
              () => {
                dateOrder = [yesterday().add(-30, 'days'), yesterday()];
                isActiveOrder = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>

      <div class="section-secondary">
        <div class="section-item">
          <div class="section-item-digit">{{ orderTrend }}</div>
          <div class="section-item-label">合计订单（单）</div>
        </div>
        <div class="section-item">
          <div class="section-item-digit">{{ paidTrend / 100 }}</div>
          <div class="section-item-label">合计支付金额（元）</div>
        </div>
        <div class="section-item">
          <div class="section-item-digit">{{ profitTrend / 100 }}</div>
          <div class="section-item-label">合计收益（元）</div>
        </div>
      </div>

      <div class="chart-main">
        <ve-line height="360px" :colors="['#FBF2E7', '#DCEBFA']" :data="chartDataOrder" :settings="{ area: true }" :legend="{ left: 0, bottom: 0 }"></ve-line>
      </div>
    </div>

    <div class="container section">
      <div class="section-chart-title">
        营销走势
        <div class="section-chart-op">
          <el-date-picker v-model="dateCoupon" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveCoupon === 7 }"
            v-on:click="
              () => {
                dateCoupon = [yesterday().add(-7, 'days'), yesterday()];
                isActiveCoupon = 7;
              }
            "
            >最近7天</span
          >
          <span
            class="date-shortcut"
            v-bind:class="{ active: isActiveCoupon === 30 }"
            v-on:click="
              () => {
                dateCoupon = [yesterday().add(-30, 'days'), yesterday()];
                isActiveCoupon = 30;
              }
            "
            >最近30天</span
          >
        </div>
      </div>

      <div class="section-secondary">
        <div class="section-item">
          <div class="section-item-digit">{{ sentCouponTrend }}</div>
          <div class="section-item-label">发放券数</div>
        </div>
        <div class="section-item">
          <div class="section-item-digit">{{ usedCouponTrend }}</div>
          <div class="section-item-label">使用券数</div>
        </div>
        <div class="section-item">
          <div class="section-item-digit">{{ rateCouponTrend }}%</div>
          <div class="section-item-label">优惠券使用率</div>
        </div>
      </div>

      <div class="chart-main">
        <ve-line height="360px" :colors="['#FBF2E7', '#DCEBFA']" :data="chartDataCoupon" :settings="{ area: true }" :legend="{ left: 0, bottom: 0 }"></ve-line>
      </div>
    </div>

    <div class="container section section-two-col">
      <div class="section-left">
        <div class="section-chart-title">
          用户分析
          <div class="section-chart-op">
            <el-date-picker v-model="dateUser" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <span
              class="date-shortcut"
              v-bind:class="{ active: isActiveUser === 7 }"
              v-on:click="
                () => {
                  dateUser = [yesterday().add(-7, 'days'), yesterday()];
                  isActiveUser = 7;
                }
              "
              >最近7天</span
            >
            <span
              class="date-shortcut"
              v-bind:class="{ active: isActiveUser === 30 }"
              v-on:click="
                () => {
                  dateUser = [yesterday().add(-30, 'days'), yesterday()];
                  isActiveUser = 30;
                }
              "
              >最近30天</span
            >
          </div>
        </div>

        <div class="section-secondary">
          <div class="section-item">
            <div class="section-item-digit">{{ todayUserTrend }}</div>
            <div class="section-item-label">今日新增用户</div>
          </div>
          <div class="section-item">
            <div class="section-item-digit">{{ userTrend }}</div>
            <div class="section-item-label">新增用户总计</div>
          </div>
        </div>

        <div class="chart-main">
          <ve-line height="360px" :colors="['#FBF2E7', '#DCEBFA']" :data="chartDataUser" :settings="{ area: true }" :legend="{ left: 0, bottom: 0 }"></ve-line>
        </div>
      </div>

      <div class="section-right">
        <div class="seciont-right-title">热销地区TOP5</div>
        <div style="margin-bottom: 28px;">
          <ve-bar height="200px" :grid="{ top: 0, bottom: 0 }" :settings="{ dataOrder: { label: '用户数', order: 'desc' } }" :legend-visible="false" :data="chartDataUserTop5" :xAxis="{ show: false }"></ve-bar>
        </div>

        <div class="seciont-right-title">性别分布</div>
        <div class="chart-gender">
          <div class="chart-gender-item man" v-bind:style="{ width: genderManW + '%' }" v-if="genderMan > 0">
            <span>男 {{ genderMan }}%</span>
          </div>
          <div class="chart-gender-item unknown" v-if="genderUnkown > 0" v-bind:style="{ width: genderUnkownW + '%' }">
            <span>未知 {{ genderUnkown }}%</span>
          </div>
          <div class="chart-gender-item woman" v-bind:style="{ width: genderWomanW + '%' }" v-if="genderWoman > 0">
            <span>女 {{ genderWoman }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
import VeLine from 'v-charts/lib/line.common';
import VeBar from 'v-charts/lib/bar.common';
import moment from 'moment';

const yesterday = () => {
  const temp = moment(new Date()).add(-1, 'days');
  return moment([temp.year(), temp.month(), temp.date()]);
};

export default {
  name: 'Statistics',
  components: {
    VeLine,
    VeBar
  },
  data() {
    return {
      token: getToken(),
      orderTotal: 0,
      paidTotal: 0,
      profitTotal: 0,

      dateOrder: [yesterday().add(-7, 'days'), yesterday()],
      orderTrend: 0,
      paidTrend: 0,
      profitTrend: 0,
      chartDataOrder: {
        columns: ['日期', '支付金额', '有效订单数'],
        rows: []
      },
      isActiveOrder: 7,

      dateCoupon: [yesterday().add(-7, 'days'), yesterday()],
      sentCouponTrend: 0,
      usedCouponTrend: 0,
      rateCouponTrend: 0,
      chartDataCoupon: {
        columns: ['日期', '优惠券发放', '优惠券使用'],
        rows: []
      },
      isActiveCoupon: 7,

      dateUser: [yesterday().add(-7, 'days'), yesterday()],
      todayUserTrend: 0,
      userTrend: 0,
      chartDataUser: {
        columns: ['日期', '新增用户'],
        rows: []
      },
      isActiveUser: 7,

      chartDataUserTop5: {
        columns: ['地区', '用户数'],
        rows: []
      },

      genderMan: 0,
      genderUnkown: 0,
      genderWoman: 0,
      genderManW: 0,
      genderUnkownW: 0,
      genderWomanW: 0
    };
  },
  watch: {
    dateOrder() {
      this.order();
    },
    dateCoupon() {
      this.coupon();
    },
    dateUser() {
      this.user();
    }
  },
  async mounted() {
    rpc(
      'StoreStatisticsService.GetOrderStatistics',
      M('StatusListTimeWithToken', {
        token: M('Token', { token: this.token }),
        statuslistList: [1, 2, 3, 4, 12]
      })
    ).then(res => {
      this.orderTotal = res.count;
      this.paidTotal = res.paidamount;
      this.profitTotal = res.profit;
    });

    rpc(
      'StoreStatisticsService.GetUserStatistics',
      M('TimeWithToken', {
        token: M('Token', { token: this.token }),
        createdatgreaterthan: yesterday()
          .add(1, 'days')
          .unix()
      })
    ).then(res => {
      this.todayUserTrend = res.count;
    });

    rpc(
      'StoreStatisticsService.GetUserProvinceStatisticsList',
      M('TimeWithToken', {
        token: M('Token', { token: this.token })
      })
    ).then(res => {
      this.chartDataUserTop5.rows = res.userprovincestatisticslistList
        .map(v => ({
          地区: v.province,
          用户数: v.count
        }))
        .slice(0, 5);
    });

    rpc(
      'StoreStatisticsService.GetUserGenderStatisticsList',
      M('TimeWithToken', {
        token: M('Token', { token: this.token })
      })
    ).then(res => {
      res.usergenderstatisticslistList.forEach(v => {
        if (v.gender === 0) {
          this.genderUnkown = v.count;
        }
        if (v.gender === 1) {
          this.genderMan = v.count;
        }
        if (v.gender === 2) {
          this.genderWoman = v.count;
        }
      });
      this.genderManW = this.genderUnkown + this.genderMan + this.genderWoman ? parseInt((this.genderMan / (this.genderUnkown + this.genderMan + this.genderWoman)) * 100) : 0;
      this.genderWomanW = this.genderUnkown + this.genderMan + this.genderWoman ? parseInt((this.genderWoman / (this.genderUnkown + this.genderMan + this.genderWoman)) * 100) : 0;
      this.genderUnknownW = 100 - this.genderManW - this.genderWomanW;
    });

    this.order();
    this.coupon();
    this.user();
  },
  methods: {
    order() {
      const begin = moment(this.dateOrder[0]);
      const end = moment(this.dateOrder[1]);
      rpc(
        'StoreStatisticsService.GetOrderDayStatisticsList',
        M('TimeWithToken', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(1, 'days').unix()
        })
      ).then(res => {
        let orderTrend = 0;
        let paidTrend = 0;
        let profitTrend = 0;
        res.orderdaystatisticslistList.forEach(v => {
          orderTrend += v.count;
          paidTrend += v.paidamount;
          profitTrend += v.profit;
        });
        this.orderTrend = orderTrend;
        this.paidTrend = paidTrend;
        this.profitTrend = profitTrend;

        let rows0 = res.orderdaystatisticslistList.map(v => ({
          日期: v.day,
          支付金额: v.paidamount / 100,
          有效订单数: v.count
        }));
        let rows = [];
        for (let b = begin; b.isBefore(end); b.add(1, 'days')) {
          rows.push(
            rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
              日期: b.format('YYYY-MM-DD'),
              支付金额: 0,
              有效订单数: 0
            }
          );
        }
        this.chartDataOrder.rows = rows;
      });
    },
    coupon() {
      const begin = moment(this.dateCoupon[0]);
      const end = moment(this.dateCoupon[1]);
      rpc(
        'StoreStatisticsService.GetCouponDayStatisticsList',
        M('TimeWithToken', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(1, 'days').unix()
        })
      ).then(res => {
        let sentCouponTrend = 0;
        let usedCouponTrend = 0;
        let rateCouponTrend = 0;
        res.coupondaystatisticslistList.forEach(v => {
          sentCouponTrend += v.sentcount;
          usedCouponTrend += v.usedcount;
        });
        this.sentCouponTrend = sentCouponTrend;
        this.usedCouponTrend = usedCouponTrend;
        this.rateCouponTrend = sentCouponTrend ? parseInt((usedCouponTrend / sentCouponTrend) * 10000) / 100 : 0;

        let rows0 = res.coupondaystatisticslistList.map(v => ({
          日期: v.day,
          优惠券发放: v.sentcount,
          优惠券使用: v.usedcount
        }));
        let rows = [];
        for (let b = begin; b.isBefore(end); b.add(1, 'days')) {
          rows.push(
            rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
              日期: b.format('YYYY-MM-DD'),
              优惠券发放: 0,
              优惠券使用: 0
            }
          );
        }
        this.chartDataCoupon.rows = rows;
      });
    },
    user() {
      const begin = moment(this.dateUser[0]);
      const end = moment(this.dateUser[1]);
      rpc(
        'StoreStatisticsService.GetUserDayStatisticsList',
        M('TimeWithToken', {
          token: M('Token', { token: this.token }),
          createdatgreaterthan: begin.unix(),
          createdatlessthan: end.add(1, 'days').unix()
        })
      ).then(res => {
        let userTrend = 0;
        res.userdaystatisticslistList.forEach(v => {
          userTrend += v.count;
        });
        this.userTrend = userTrend;

        let rows0 = res.userdaystatisticslistList.map(v => ({
          日期: v.day,
          新增用户: v.count
        }));
        let rows = [];
        for (let b = begin; b.isBefore(end); b.add(1, 'days')) {
          rows.push(
            rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
              日期: b.format('YYYY-MM-DD'),
              新增用户: 0
            }
          );
        }
        this.chartDataUser.rows = rows;
      });
    },
    yesterday
  }
};
</script>

<style scoped>
.section {
  padding-left: 24px;
}
.section-two-col {
  display: flex;
}
.section-left {
  flex: 1;
  padding-right: 24px;
}
.section-right {
  min-width: 300px;
  margin-top: 60px;
}
.seciont-right-title {
  font-size: 18px;
  color: #666;
  line-height: 2.225;
  margin-bottom: 12px;
}
.unit {
  font-size: 16px;
  font-weight: normal;
  margin: 0 6px;
  color: #666;
  line-height: 1.375;
}
.date-shortcut {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  border: 1px solid #dcdfe6;
  color: #c0c4cc;
  line-height: 38px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 12px;
  cursor: pointer;
}
.date-shortcut.active {
  color: #ff4f4f;
  border: 1px solid #ff4f4f;
}

.section-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 24px;
  font-size: 24px;
  color: #333;
  font-weight: 500;
}
.section-primary {
  display: flex;
  padding-bottom: 24px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 24px;
}

.section-item {
  min-width: 180px;
}
.section-item-label {
  font-size: 17px;
  color: #999;
}
.section-item-digit {
  font-size: 28px;
  font-weight: 500;
  line-height: 1;
  margin-top: 20px;
  color: #333;
  display: flex;
  align-items: flex-end;
}

.section-chart-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 12px;
}

.section-chart-op {
  display: flex;
}

.section-secondary {
  display: flex;
}
.section-secondary .section-item-digit {
  font-size: 22px;
  margin-bottom: 20px;
}

.chart-gender {
  font-size: 0;
}

.chart-gender-item {
  float: left;
  display: inline-block;
  height: 24px;
  position: relative;
}
.chart-gender-item::after {
  content: ' ';
  position: absolute;
  top: 0;
  right: 2px;
  left: 0;
  bottom: 0;
  border-radius: 2px;
}
.chart-gender-item span {
  position: absolute;
  bottom: -18px;
  color: #666;
  left: 0;
  font-size: 12px;
  min-width: 48px;
}

.chart-gender-item.man::after {
  background-color: #037fff;
}
.chart-gender-item.unknown::after {
  background-color: #cccccc;
}
.chart-gender-item.woman::after {
  background-color: #ff4f4f;
}
.chart-gender-item.woman span {
  right: 0;
  left: auto;
}
</style>
